// IMPORTANT NOTE: Do not change this file manually.
// The project's version will be automatically updated when the `npm run release` command is run.
/**
 * The current version of OCC UI.
 */
export const occUiVersion = '14.0.1';
//# sourceMappingURL=version.js.map